import { render, staticRenderFns } from "./ProductConfiguratorAddToCart.vue?vue&type=template&id=b0fb9d6c&"
import script from "./ProductConfiguratorAddToCart.js?vue&type=script&lang=js&"
export * from "./ProductConfiguratorAddToCart.js?vue&type=script&lang=js&"
import style0 from "./ProductConfiguratorAddToCart.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports